import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from "react";
var ChevronDown = function(props) {
    return /*#__PURE__*/ _jsx("svg", {
        width: "32",
        height: "32",
        viewBox: "0 0 32 32",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        children: /*#__PURE__*/ _jsx("path", {
            d: "M27.3337 10.3333L16.0003 21.6667L4.66699 10.3333",
            stroke: "#e60000",
            strokeLinecap: "round"
        })
    });
};
export default /*#__PURE__*/ memo(ChevronDown);
